// @vue/component
export default {
  computed: {
    workerOnBoardingRoutesQueryParams() {
      const {
        client_uuid, location_uuid, // eslint-disable-line camelcase
      } = this.$route.query;

      return {
        client_uuid, location_uuid,
      };
    },
    routes() {
      const routeNames = {
        oneTimePassAssessment: 'oneTimePassAssessment',
        workerOnBoarding: 'workerOnBoardingBusinessSearch',
        businessSearch: 'workerOnBoardingBusinessSearch',
        requestAccess: 'workerOnBoardingRequestAccess',
        accessRequestSent: 'workerOnBoardingAccessRequestSent',
        emailReminderSent: 'workerOnBoardingEmailReminderSent',
        invitationsSent: 'workerOnBoardingInvitationsSent',
        sendInvitations: 'workerOnBoardingSendInvitations',
        unregisteredBusiness: 'workerOnBoardingUnregisteredBusiness',
      };
      const customConfig = {};
      const keys = Object.keys(routeNames);

      return _.zipObject(keys, keys.map(key => ({
        name: routeNames[key],
        query: this.workerOnBoardingRoutesQueryParams,

        ...(customConfig[key] || {}),
      })));
    },
  },
};
